/**
 * Miscellaneous config for better performance
 *
 * @type {ngConfig}
 * @see https://docs.angularjs.org/guide/production
 */
function tmrPerformanceConfig($compileProvider) {
  'ngInject'
  // Disable debug info in production.
  $compileProvider.debugInfoEnabled(process.env.env != 'production')
  // Disable comment and css class directives.
  $compileProvider.commentDirectivesEnabled(false)
  $compileProvider.cssClassDirectivesEnabled(false)
}

export { tmrPerformanceConfig as config }
